<template>
  <div class="flex flex-col items-stretch">
    <component v-for="(field, i) of fields" :key="i" :is="componentByType(field.type)" v-bind="field.props" v-model="formdata[field.name]" />
    <div class="flex">
      <button class="btn btn-2 flex-1 mr-1" @click="cancel">{{$t('cancel')}}</button>
      <button class="btn btn-1 flex-1 ml-1" @click="confirm">{{$t('ok')}}</button>
    </div>
  </div>
</template>

<script>
import TextInput from '../TextInput'
import PasswordInput from "../PasswordInput";
import RadioInput from "../RadioInput";
import SelectInput from "../SelectInput";
import ChecksInput from "../ChecksInput";
import Button from "../Button";

import { MODAL_HIDE } from '../../store/mutation-types';

const fieldTypeMap = {
  text: TextInput,
  password: PasswordInput,
  radio: RadioInput,
  select: SelectInput,
  checks: ChecksInput,
  button: Button
}

const getDefaultValue = {
  text: () => '',
  password: () => '',
  radio: () => '',
  select: () => '',
  checks: () => [],
}



export default {
  data() {
    const formdata = {}

    this.fields.forEach(field => {
      const v = field.value ? field.value : getDefaultValue[field.type]()
      formdata[field.name] = v
    });

    return {
      formdata
    }
  },
  props: {
    fields: Array
  },
  components: {
    TextInput,
    PasswordInput,
    RadioInput,
    SelectInput,
    ChecksInput,
  },
  methods: {
    componentByType(type) {
      return fieldTypeMap[type]
    },
    cancel() {
      this.$emit('cancel')
      this.$store.commit('modal/' + MODAL_HIDE)
    },
    confirm() {
      this.$emit('confirm', this.formdata)
      this.$store.commit('modal/' + MODAL_HIDE)
    }
  }
}
</script>

<style>

</style>